<template>
  <div class="search-box-open float-left">
    <a href="#" class="d-block" @click.prevent="clickStopPrevent">
      <object
        class="search-icon"
        :data="searchSvg"
        type="image/svg+xml"
      ></object>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchSvg: require("../../../assets/svg/search-icon.svg")
    };
  },
  props: {
    clickStopPrevent: Function
  }
};
</script>
